import React, {useCallback} from "react";
import './styles.scss';
import { Link, useHistory } from 'react-router-dom'
import Batter from './Batter';
import Pitcher from "./Pitcher";
import {useDispatch, useSelector} from "react-redux";
import {setCondition} from "../../../../actions/detail-search";
import {TOTAL_DETAIL} from "../main-search/constant";
import buildSearch from '../main-search/buildSearch';
function SetupAnalysis () {
    let history = useHistory();
    const dispatch = useDispatch();
    const dataSearch = useSelector(state => state.detailSearch);
    const onChange = useCallback((values, field) => {
        dispatch(setCondition(values, field))
    },[]);
    return <div className="setup-search">
        <div className='title-setup-search'>
            <img alt='back' src='./../img/ic_arrow_left.svg' onClick={ () => history.push('/detailed-search') } />
            <div style={{ width: '20%'} }>
                <h2>分析項目設定</h2>
            </div>
            <div className='btn-container'>
                <div >
                    <button className='btn-search-top'>
                        <Link to='/detailed-search/result'><p style={{ color: 'white'}}>決定</p></Link>
                    </button>
                </div>
            </div>

        </div>
        <div>
            <div className={'analysis-container'}>
                   <div className={'analysis-title'}>
                       <p>対象選択</p>
                   </div>
                {
                    dataSearch.type === 'pitchers' ? <Pitcher selected={dataSearch[TOTAL_DETAIL.COLUMN_GROUP]} onChange={onChange}/> :
                        <Batter selected={dataSearch[TOTAL_DETAIL.COLUMN_GROUP]} onChange={onChange}/>
                }
            </div>

        </div>
        <div className={'last-li'}>
            <div className='btn-send-search'>
                <button>
                    <Link to='/detailed-search/result'>決定</Link>
                </button>
            </div>
        </div>
    </div>
}

export default SetupAnalysis;
